import MuiSelect from '@mui/material/Select';
import { styled } from '@mui/material/styles';

export const StyledAccessLevelSelect = styled(MuiSelect)(({ theme }) => ({
  '& .MuiSelect-select': {
    alignItems: 'center',
    display: 'flex',
    padding: theme.spacing(1.5),
  },
  borderRadius: 12,
}));
